/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @type {string} Auditions action types.
 */

export const SET_LOADING = '[RECRUITER_AUDITIONS] SET_LOADING';
export const SET_ACTIVE_AUDITION_LIST = '[RECRUITER_AUDITIONS] SET_ACTIVE_AUDITION_LIST';
export const APPEND_ACTIVE_AUDITION_LIST = '[RECRUITER_AUDITIONS] APPEND_ACTIVE_AUDITION_LIST';
export const SET_ACTIVE_AUDITION_LIST_META = '[RECRUITER_AUDITIONS] SET_ACTIVE_AUDITION_LIST_META';
export const SET_PAST_AUDITION_LIST = '[RECRUITER_AUDITIONS] SET_PAST_AUDITION_LIST';
export const APPEND_PAST_AUDITION_LIST = '[RECRUITER_AUDITIONS] APPEND_PAST_AUDITION_LIST';
export const SET_PAST_AUDITION_LIST_META = '[RECRUITER_AUDITIONS] SET_PAST_AUDITION_LIST_META';
export const SET_DRAFT_AUDITION_LIST = '[RECRUITER_AUDITIONS] SET_DRAFT_AUDITION_LIST';
export const APPEND_DRAFT_AUDITION_LIST = '[RECRUITER_AUDITIONS] APPEND_DRAFT_AUDITION_LIST';
export const SET_DRAFT_AUDITION_LIST_META = '[RECRUITER_AUDITIONS] SET_DRAFT_AUDITION_LIST_META';
